<template>
  <ul :class="`${metadataType}-list`">
    <li v-for="(genre, index) in genreList" :key="index" >
      <template v-if="genre.text">{{ genre.text }}</template>
      <template v-else><AgeGrade :target-age="contentInfo.targetage" :section="'vod'" /></template>
    </li>
  </ul>
<!--  <span class="desc-info">-->
<!--    <template v-for="(genre, index) in genreList" >-->
<!--       <span :key="index">{{genre.text}}</span>-->
<!--       <i v-if="index < genreList.length - 1" :key="'genre_' + index" class="icon-dotted"></i>-->
<!--    </template>-->
<!--  </span>-->
</template>
<script>
import { get } from 'lodash'
import AgeGrade from '@/components/play/AgeGrade'

export default {
  name: 'VodGenre',
  components: {
    AgeGrade
  },
  props: {
    metadataType: {
      type: String,
      default: 'metadata'// metadata | tag
    },
    contentInfo: {
      type: Object,
      default: () => {}
    }
  },

  // data () {
  //   return {
  //     genreList: []
  //   }
  // },
  // props: ['contentInfo', 'isGlobal'],
  computed: {
    genreList () {
      // console.log('computed genreList', this.setData())
      return this.setListData()
    }
    // targetage () {
    //   const age = get(this.contentInfo, 'targetage', '')
    //   if (age !== '') {
    //     if (Number(age) < 20) {
    //       return age === '0' ? '전체' : `${age}세`
    //     } else {
    //       return '청불'
    //     }
    //   } else {
    //     return ''
    //   }
    // },
    // genreListOld () {
    //   let list = []
    //   const { episodenumber, releasedate, releaseweekday, genretext, playtime } = this.contentInfo
    //   if (episodenumber) {
    //     list.push({ text: `${episodenumber}회` })
    //   }
    //   if (!this.isGlobal) {
    //     list.push({ text: `${releasedate}(${releaseweekday})` })
    //   }
    //   if (genretext !== '') {
    //     list.push({ text: genretext })
    //   }
    //   if (playtime !== '0' && (Math.floor(Number(playtime) / 60) > 0)) {
    //     list.push({ text: `${Math.floor(Number(playtime) / 60)}분` })
    //   }
    //   if (this.targetage !== '') {
    //     list.push({ text: this.targetage })
    //   }
    //   return list
    // }
  },
  methods: {
    setListData () {
      switch (this.metadataType) {
        case 'metadata' : return this.getMetadataList()
        case 'tag' : return this.getTagList()
        default : return []
      }
    },
    getMetadataList () {
      const { season_list: seasonList, targetage, genretext } = this.contentInfo
      const seasonInfo = { text: `시즌 ${get(seasonList, 'count', '1')}개` }
      const ageInfo = targetage
      const genreInfo = { text: genretext }
      return [seasonInfo, ageInfo, genreInfo].filter(item => item)
    },
    getTagList () {
      const { issubtitle, qualities } = this.contentInfo
      const cc = issubtitle.toLowerCase() === 'y' ? 'cc' : null
      // const atmos = isatmos.toLowerCase() === 'y' ? 'dolby-atmos' : null
      const quality = qualities.mediatypes[0]

      let mediatype = ''
      switch (quality) {
        // dolby-vision / HDR10 / dolby-atmos
        case 'DV' : mediatype = 'dolby-vision'
          break
        case 'HDR10' : mediatype = 'HDR10'
          break
        case 'SDR' : mediatype = ''
          break
      }

      return [cc, mediatype]
        .filter(item => item)
        .map(tags => `<img src="${require('@/assets/images/detail/ico_badges_' + tags + '.png')}" :alt="'${tags} 아이콘'">`)
    }
  }
}
</script>
